import { Component, OnInit } from '@angular/core';
import { AngularFrameworkCourses, JrFrontCourses } from '@shared/mock/all-courses';
import { CourseIntro } from '@shared/models/course-intro.model';
import { Router } from '@angular/router';
import { ApplyModalService } from '@shared/services/apply-modal/apply-modal.service';

@Component({
  selector: 'app-chapters',
  templateUrl: './chapters.component.html',
  styleUrls: ['./chapters.component.scss'],
})
export class ChaptersComponent implements OnInit {
  courses = {} as { [key: string]: CourseIntro };
  currentRoute: string;

  constructor(
    private router: Router,
    public applyModalService: ApplyModalService
  ) {
    this.currentRoute = this.router.url;
    if (this.currentRoute.includes('junior-front-end-developer')) {
      this.courses = JrFrontCourses;
    } else if (this.currentRoute.includes('angular-framework')) {
      this.courses = AngularFrameworkCourses;
    }
  }

  ngOnInit(): void {}
}
